import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { useHistory, useLocation } from 'react-router';
import { PropsFromRedux } from '.';
import paymentImg from '../../../../assets/images/payment-failed.svg';
import { API_KEYS } from '../../../../interfaces/api';


interface Props extends PropsFromRedux {}



const PaymentFailedShopper: React.FC<Props> = ({ 
  hideModal,
  showModal,
  modal, 
  getHistory, 
  resetApi }) => {

  React.useEffect(
    () => () => {
      resetApi(API_KEYS.CHARGE_PERSONAL_SHOPPING_WALLET);
    },
    [resetApi]
  );

  const history = useHistory();
  const location = useLocation();

  const closeModal = () => {
    hideModal();
  }

  const goToHistory = () => {
    hideModal();
    getHistory();
    history.push('/shopping-history');
  }

  
  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return( 
    <div className="w-full px-2 bg-white lg:px-12 py-12 relative">
        <button type="button" aria-label="Close" onClick={closeModal}>
         <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
    <div className="w-full my-2 flex items-center justify-center ">
      <img src={paymentImg} alt="GIG App" className="w-28 my-4" />
    </div>
     <div className="w-full my-6 text-center">
         <h2 className="mb-1 text-lg font-medium text-black">Payment Failed</h2>
         <p className=" w-96 text-sm text-gray-400">We would process and send a proforma invoice once availability of item is comfirmed.</p>
      </div>
      <button className="w-full bg-secondary font-medium text-sm rounded text-white py-3 my-6" type="button" onClick={() => goToHistory()}>Close</button>
  </div>
  );
  // </ModalWrapper>
};

export default PaymentFailedShopper;
